import { Button } from '@/components/ui/button'
import { AppHeader } from '@/components/ui/AppHeader'
import { ChevronLeft } from 'lucide-react'

interface PageHeaderProps {
    title: string
    icon?: React.ReactNode
    onBack?: () => void
}

export const PageHeader = ({ title, icon, onBack }: PageHeaderProps) => (
    <header className="bg-white shadow sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-2">
                <div className="flex items-center gap-2 sm:gap-4 min-w-0">
                    {onBack && (
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={onBack}
                            className="flex items-center gap-1 shrink-0"
                        >
                            <ChevronLeft className="h-4 w-4" />
                            <span className="hidden sm:inline">Retour</span>
                        </Button>
                    )}
                    <h1 className="text-lg sm:text-xl font-bold text-gray-900 flex items-center gap-2 min-w-0">
                        {icon && <span className="shrink-0">{icon}</span>}
                        <span className="truncate">{title}</span>
                    </h1>
                </div>
                <AppHeader />
            </div>
        </div>
    </header>
)
